<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Configurações — Usuários: Listagem e exibição
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  listar
        |  usuários e
        strong  abrir
        |  a ficha de exibição em
        strong  Configurações → Usuários → Listar usuários
        | .

      .toast.toast-primary
        | Exige
        strong  Sistema → Usuários → Listar
        |  e
        strong  Sistema → Usuários → Exibir
        | .

      h5.h5 1. Abrir Usuários
      ol
        li No menu lateral, clique em
          strong  Configurações
          | .
        li Expanda
          strong  Usuários
          |  e clique em
          strong  Listar usuários
          | .

      h5.h5 2. Filtros
      p
        | Acima da grade ficam
        strong  CPF/CNPJ
        | ,
        strong  Nome
        | ,
        strong  Perfil
        | ,
        strong  Departamento
        | , o checkbox
        strong  Prefeitura
        |  (marcado por padrão) e os rádios
        strong  Ativo
        |  /
        strong  Inativo
        | .
      ol
        li Preencha os critérios desejados.
        li Clique na
          strong  lupa
          |  para filtrar.

      h5.h5 3. Listagem
      p
        | Cada usuário aparece em um
        strong  card
        |  com CPF/CNPJ (login), nome/razão social, e-mail e o badge
        strong  Validado por
        | .
      figure.manual-figure
        img(:src="imgLista" alt="Listagem de usuários")
      ol
        li Use a paginação no rodapé se houver várias páginas.
        li No rodapé do card, clique em
          strong  Exibir
          |  (olho) ou
          strong  Alterar
          |  (lápis).

      h5.h5 4. Exibir o usuário
      p
        | A ficha mostra CPF/CNPJ, nome e e-mail no cabeçalho, depois
        |  validação, matrícula, código fiscal, se recebe OS-m, se é fiscal,
        |  cargo, data de admissão e perfis. Se houver pessoa vinculada,
        |  aparecem módulos e dados cadastrais. Também há blocos de
        |  comentários, validação da conta e acessos externos (Gov.br etc.).
      figure.manual-figure
        img(:src="imgShow" alt="Exibição do usuário")
      ol
        li No rodapé, use
          strong  Afastamentos
          |  (exige cargo e permissão de produtividade),
          strong  Logs
          |  ou
          strong  Alterar
          | .
        li A edição e os afastamentos estão no manual
          strong  Usuários: Editar e afastamentos
          | .

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgLista: require("@/assets/manuais/35-config-usuarios-lista.png"),
      imgShow: require("@/assets/manuais/35a-config-usuarios-show.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
